const r = {
  name: "Globe",
  dimensions: { width: 22, height: 22 },
  content: `
    <g fill="none" stroke="currentColor" stroke-width="2">
        <circle r="10" transform="matrix(1 0 0 -1 11 11)"/>
        <ellipse rx="4" ry="10" transform="matrix(1 0 0 -1 11 11)"/>
        <path d="M1 11L21 11" />
    </g>
  `
};
export {
  r as Globe
};
